const $footer = document.querySelector('[data-role=footer]');
const $buyNow = document.querySelector('[data-role=buy-now]');

if ($footer && $buyNow) {
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				$buyNow?.classList?.add('_hide');
			} else {
				$buyNow?.classList?.remove('_hide');
			}
			
		});
	});

	observer.observe($footer);
}